import { $http, $router } from '@/main';
import store from '@/store';

// When the request succeeds
const success = (response) => {
  store.dispatch('Courses/getCourses', response);
};
const failure = (error) => {
  store.dispatch('Errors/error', error);
};


export default () => {
  $http.get('/courses').then((response) => {
    success(response.data);
  }).catch((error) => {
    failure(error);
  });
};
